// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__cgKSk","label":"style_label__UTwuT","text":"style_text__3TIhC","prevPrice":"style_prevPrice__zM0-9","currentPrice":"style_currentPrice__Sh5jF"};